import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance90 = () => {
    let winners = ["276", "48", "415", "219"];

  return <IndividualTable matchType={"8"} gender="F" event="90" subTitle="TarscaShild" data={sampleData2} topRankCount="4" winners={winners}/>;
};
export default Distance90;
